import { Environment } from '@chegg/commerce-utils';
export var CheggAndEComEnvMap = {
  dev: Environment.DEVELOPMENT,
  test: Environment.TEST,
  stage: Environment.STAGING,
  prod: Environment.PRODUCTION
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/dist/esm/components/WtOneClick/constants.js
// module id = 5219
// module chunks = 11